import React, { useEffect, useRef, useState } from "react";
import {
  documentDownloaded,
  downloadDocument,
  getDownloadedDocumentData,
} from "../store/documents";
import { useDispatch, useSelector } from "react-redux";
import { getAlert } from "../../Services/appAlerts";

const useDocDownload = () => {
  const [doc, setDoc] = useState(null);
  const [downloadingDocId, setDownloadingDocId] = useState(null);
  const pendingDocIdRef = useRef(null);
  const downloadedDocumentDataSelector = useSelector(getDownloadedDocumentData);

  const dispatch = useDispatch();

  const handleDownloadFile = async (item) => {
    const docId = item?.docId || item?.id;
    if (!docId) return;

    // Clear any prior download data in Redux store to avoid stale URL reuse
    dispatch(documentDownloaded(null));
    pendingDocIdRef.current = docId;
    setDownloadingDocId(docId);
    setDoc(item);
    dispatch(downloadDocument(docId));

    // Safety timeout to clear loading indicator if request fails
    setTimeout(() => {
      setDownloadingDocId((prev) => (prev === docId ? null : prev));
      if (pendingDocIdRef.current === docId) {
        pendingDocIdRef.current = null;
        setDoc(null);
      }
    }, 8000);
  };

  useEffect(() => {
    if (downloadedDocumentDataSelector?.uploadUrl && pendingDocIdRef.current && doc) {
      try {
        window.open(downloadedDocumentDataSelector.uploadUrl, "_blank");
      } catch (error) {
        getAlert("", error?.message, "error");
      } finally {
        pendingDocIdRef.current = null;
        dispatch(documentDownloaded(null));
        setDownloadingDocId(null);
        setDoc(null);
      }
    }
  }, [downloadedDocumentDataSelector, doc, dispatch]);

  return [handleDownloadFile, downloadingDocId];
};

export default useDocDownload;
